var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"defaultBg"},[_c('v-main',[_c('router-view'),(_vm.viewOnepoint)?_c('div',{staticClass:"onepointArea",on:{"click":_vm.goTop}},[_c('img',{attrs:{"src":"/images/common/logo_yu.png"}})]):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }